import { z } from 'zod';
/**
 * Esquemas de identidad y sesion.
 * Convenciones de Enteratek, seccion 6: las validaciones se definen UNA sola
 * vez aqui y las reutilizan interfaz, API, jobs e importaciones.
 */
export const PERFILES = [
    'PERFIL_ADMIN',
    'PERFIL_GERENTE',
    'PERFIL_DESPACHADOR',
    'PERFIL_PLANEACION',
    'PERFIL_CLIENTE',
];
export const MODULOS = [
    'MOD_TABLERO',
    'MOD_CONSULTA',
    'MOD_TICKETS',
    'MOD_CLIENTES',
    'MOD_CONTRATOS',
    'MOD_PROYECTOS',
    'MOD_SITIOS',
    'MOD_IDC',
    'MOD_INVENTARIO',
    'MOD_RESGUARDO',
    /* El second touch. La 0021 trajo sus tablas pero no el modulo, porque el
       movil entra por sus propias rutas y su permiso cuelga de MOD_TICKETS.
       La web si lo necesita: su menu se dibuja desde los permisos de modulo. */
    'MOD_STAGING',
    /* La torre de control. Entra como modulo propio y no colgado de
       MOD_TABLERO porque su alcance es distinto: el resumen ejecutivo lo ve
       quien mira numeros, y la torre la despacha quien actua sobre ellos. */
    'MOD_TORRE',
    'MOD_CATALOGOS',
    'MOD_AUDITORIA',
    'MOD_AJUSTES',
];
export const ACCIONES = ['leer', 'escribir'];
/** RFC 5322 en lo practico, mas minusculas forzadas para deduplicar. */
export const esquemaCorreo = z.string().trim().toLowerCase().max(254).email();
export const esquemaContrasena = z.string().min(12).max(128);
export const esquemaLogin = z.object({
    correo: esquemaCorreo,
    contrasena: esquemaContrasena,
    /* Seis digitos del autenticador. Solo si la cuenta lo tiene activo. */
    totp: z
        .string()
        .regex(/^[0-9]{6}$/)
        .optional(),
});
export const esquemaCambioContrasena = z.object({
    contrasena_actual: z.string().min(1).max(128),
    contrasena_nueva: esquemaContrasena,
});
export const esquemaUsuarioNuevo = z
    .object({
    nombre: z.string().trim().min(3).max(120),
    correo: esquemaCorreo,
    /* E.164 con pais. */
    telefono: z
        .string()
        .regex(/^\+[1-9][0-9]{7,14}$/)
        .optional(),
    perfil: z.enum(PERFILES),
    cliente_id: z.string().uuid().optional(),
})
    .refine((u) => (u.perfil === 'PERFIL_CLIENTE') === (u.cliente_id !== undefined), {
    message: 'Un perfil cliente exige cliente_id, y ningun otro perfil lo lleva',
});
//# sourceMappingURL=sesion.js.map